import axios from 'axios';
import {isJSON} from './tool';
import handleAuthExpired from '../../mobile/utils/authExpired';

function Ajax(
    {
        url = '/',
        method = 'post',
        data = {},
        info = {},
        params = {},
        async = true, //默认异步，同步false
        loading = true,
        success = function (res) {
        },
        error = function (res, url) {
            console.error(res);
            let msgContent = JSON.stringify(res.message);
        },
        headers = {'Content-Type': 'application/json;charset=UTF-8'},
        sysParameter,
    }) {

    //异步请求
    function asyncAxios() {
        axios({
            method,
            params,
            headers,
            url,
            data,
            withCredentials: true,
            transformRequest: [
                function (data) {
                    if (headers['Content-Type'] === 'multipart/form-data') {
                        return data;
                    }
                   return JSON.stringify(data)
                }
            ],
            transformResponse: [
                function (data, headers) {
                    return isJSON(data) ? JSON.parse(data) : data;
                }
            ]
        })
            .then((res) => {
                handleAuthExpired(res);
                success(res.data);
            })
            .catch((err) => {
                error(err)
                console.log(err);
            });
    }

    //同步请求
    function syncAxios() {
        //同步
        let requestData = JSON.stringify(data);

        ajax({
            type: method,
            url, //添加自己的接口链接
            data: requestData,
            async,
            headers,
            before() {
            },
            success(str) {
                if (isJSON(str)) {
                    str = JSON.parse(str);
                }
                handleAuthExpired(str);
                success(str);
            }
        });
    }

    //执行ajax请求
    if (async) {
        //异步
        asyncAxios();
    } else {
        //同步
        syncAxios();
    }
}

function ajax(options) {

    var url = options.url || '', //请求的链接
        type = (options.type || 'get').toLowerCase(), //请求的方法,默认为get
        data = options.data, //|| JSON.stringify({}), //请求的数据
        contentType = options.contentType || '', //请求头
        dataType = options.dataType || '', //请求的类型
        async = options.async === undefined ? true : options.async, //是否异步，默认为true.
        timeOut = options.timeOut, //超时时间。
        before = options.before || function () {
        }, //发送之前执行的函数
        error = options.error || function () {
        }, //错误执行的函数
        success = options.success || function () {
        }; //请求成功的回调函数
    var timeout_bool = false, //是否请求超时
        timeout_flag = null, //超时标识
        xhr = null; //xhr对角

    // JSONP
    function createJsonp() {
        var script = document.createElement('script'),
            timeName = new Date().getTime() + Math.round(parseFloat('0.' + (+new Date() + '').split('').reverse().join('')) * 1000),
            callback = 'JSONP_' + timeName;

        window[callback] = function (data) {
            clearTimeout(timeout_flag);
            document.body.removeChild(script);
            success(data);
        };
        script.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'callback=' + callback;
        script.type = 'text/javascript';
        document.body.appendChild(script);
        setTime(callback, script);
    }

    //设置请求超时
    function setTime(callback, script) {
        if (timeOut !== undefined) {
            timeout_flag = setTimeout(function () {
                if (dataType === 'jsonp') {
                    delete window[callback];
                    document.body.removeChild(script);
                } else {
                    timeout_bool = true;
                    xhr && xhr.abort();
                }
                console.log('timeout');
            }, timeOut);
        }
    }

    // XHR
    function createXHR() {
        //由于IE6的XMLHttpRequest对象是通过MSXML库中的一个ActiveX对象实现的。
        //所以创建XHR对象，需要在这里做兼容处理。
        function getXHR() {
            if (window.XMLHttpRequest) {
                return new XMLHttpRequest();
            } else {
                //遍历IE中不同版本的ActiveX对象
                var versions = ['Microsoft', 'msxm3', 'msxml2', 'msxml1'];
                for (var i = 0; i < versions.length; i++) {
                    try {
                        var version = versions[i] + '.XMLHTTP';
                        return new ActiveXObject(version);
                    } catch (e) {
                    }
                }
            }
        }

        //创建对象。
        xhr = getXHR();
        xhr.open(type, url, async);
        //设置请求头
        if (type === 'post' && !contentType) {
            //若是post提交，则设置content-Type 为application/x-www-four-urlencoded
            xhr.setRequestHeader('Content-Type', 'application/x-www-four-urlencoded;charset=UTF-8');
        } else if (contentType) {
            xhr.setRequestHeader('Content-Type', contentType);
        }

        // 添加加签参数
        if (options.headers && options.headers['terminalType']) {
            xhr.setRequestHeader('terminalType', options.headers['terminalType']);
        }

        // 添加加解密和token参数
        if (options.headers && options.headers['token']) {
            xhr.setRequestHeader('token', options.headers['token']);
        }

        if (options.headers && options.headers['deviceId']) {
            xhr.setRequestHeader('deviceId', options.headers['deviceId']);
        }

        xhr.withCredentials = true;
        //添加监听
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (timeOut !== undefined) {
                    //由于执行abort()方法后，有可能触发onreadystatechange事件，
                    //所以设置一个timeout_bool标识，来忽略中止触发的事件。
                    if (timeout_bool) {
                        return;
                    }
                    clearTimeout(timeout_flag);
                }
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                    success(xhr.responseText);
                } else {
                    error(xhr.status, xhr.statusText);
                }
            }
        };
        //发送请求
        xhr.send(type === 'get' ? null : data);
        setTime(); //请求超时
    }

    //setData();
    before();
    if (dataType === 'jsonp') {
        createJsonp();
    } else {
        createXHR();
    }
}

export default Ajax;